import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import ErrorResponse from './ErrorResponse';
import mapSiMaxPrice from './mapSiMaxPrice';
import SiMaxPrice from './SiMaxPrice';

export interface Result {
	siMaxPrice: SiMaxPrice;
}

export default function findSiMaxPrice(client: ApiClient, userId: string, groupId: string): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/si-max-price');
	return client
		.fetch(url.expand({ userId, groupId }))
		.then((response) => response.json())
		.then((response) => ({
			siMaxPrice: mapSiMaxPrice(response.siMaxPrice),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, ErrorResponse));
}
